"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1248],{

/***/ 69773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var BottomQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top rotate-180",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomQ);


/***/ }),

/***/ 29310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var TopQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopQ);


/***/ }),

/***/ 71248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10990);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69773);
/* harmony import */ var src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29310);






var Img = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5076).then(__webpack_require__.bind(__webpack_require__, 15076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15076)
            ];
        }
    }
});
var ImgFourthSection = function(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ProjectScrubTl = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._caseFourthSectionTrigger",
                start: "`top 100%",
                scrub: 0.9
            }
        });
        ProjectScrubTl.to("._projectImg7", {
            y: -400,
            duration: 0.6
        }, "start");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pt-[100px] pb-[300px] relative _caseFourthSectionTrigger px-[2.85714rem]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid grid-cols-2 gap-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Img, {
                                href: "/case-study/13",
                                imgSrc: "/images/home/slider/13-wol.webp",
                                css: "w-[31.59722vw] -top-[5%] _projectImg7",
                                imgCss: "h-[31.59722vw]",
                                title: "Reveler.io",
                                desc: "Sub Pages Redesign"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Img, {
                                href: "/case-study/9",
                                imgSrc: "/images/home/slider/9-wol.webp",
                                css: "w-[31.59722vw] top-[70%] _projectImg7",
                                imgCss: "h-[31.59722vw]",
                                title: "Bonsai",
                                desc: "Mobile App UI/UX Design"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative top-0 mr-[10%]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[39.02778vw] w-[38.19444vw] bg-redblack xl:p-7 p-8 pr-9",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bgCaseStudyComeToghtherDesk h-full w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-redblack text-white 3xl:w-[55%] xl:w-[61%] desktop:w-[62%] w-[68%] 3xl:pb-3 absolute 3xl:top-[25%] 2xl:top-[25%] xl:top-[19%] desktop:top-[26%] 3xl:left-[18%] xl:left-[19.2%] top-[6%] left-[11%] 2xl:pb-6 2xl:pt-3 3xl:p-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "3xl:mt-[27px] mt-[20px] mb-[27px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "font-bold text-white text-[1.57143rem] leading-[1.22727em] mb-6",
                                            children: "Thinking made visual."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "leading-[1.22727em] 3xl:text-[1.57143rem] text-[1.28571rem]",
                                            children: "How you invest in how users interact with and perceive your product will ultimately make or break the success of your product."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "3xl:mt-[27px] my-[27px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ImgFourthSection);


/***/ })

}]);